import { IMAGESMAP } from "../utils/imagesMap"

/*
 *  WOMEN RESULT DATA
 */

export const kimberly = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.KIMBERLY_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.KIMBERLY_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.KIMBERLY_AFTER,
  imageDirection: "right",
  quote:
    "My hair is growing like wildflowers! I’m very happy with the results.",
  name: "Kimberly",
  tags: [
    "Visibly Thicker Hair Volume",
    "Visible Fullness",
    "Stronger Hair Growth",
  ],
  product: "Nutrafol Women’s Balance Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women’s Balance experienced significant hair growth.",
  after: "6",
  action: "Taking",
  pdp: "/women-balance/",
}

export const lydia = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.LYDIA_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.LYDIA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.LYDIA_AFTER,
  imageDirection: "right",
  quote:
    "I was experiencing a lot of breakage and I’m not seeing that anymore when I comb my hair.",
  name: "Lydia",
  tags: ["Stronger Hair Growth", "Less Shedding", "Visibly Shinier"],
  product: "Nutrafol Women’s Balance Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women’s Balance experienced significant hair growth.",
  after: "3",
  action: "Taking",
  pdp: "/women-balance/",
}

export const sherry = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.SHERRY_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.SHERRY_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.SHERRY_AFTER,
  imageDirection: "center",
  quote:
    "I had a lot of shedding and my ponytail was not as big and full as it used to be. After 6 months, I am just over the moon ecstatic with the results!",
  name: "Sherry",
  tags: ["Less Shedding", "Hair Growth", "Fuller Scalp Coverage"],
  product: "Nutrafol Women’s Balance Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women’s Balance experienced significant hair growth.",
  pdp: "/women-balance/",
  after: "6",
  action: "Taking",
}

export const lindsey = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.LINDSEY_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.LINDSEY_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.LINDSEY_AFTER,
  imageDirection: "left",
  quote:
    "It not only helped with the thickness and fullness of my hair, but also the strength and durability. People compliment me left and right about how healthy and strong my hair looks.",
  name: "Lindsey",
  tags: ["Visibly Less Shedding", "Visibly Thicker Hair Volume", "Hair Growth"],
  product: "Nutrafol Women Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women experienced significant hair growth.",
  after: "3",
  action: "Taking",
  pdp: "/nutrafol-core-for-women/",
}

export const terry = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.TERRY_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.TERRY_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.TERRY_AFTER,
  imageDirection: "left",
  quote:
    "My hair had been highly damaged from so much stress. It had broken off so much, that my loved ones were worried. Because of Nutrafol, my hair is better than ever. No more breakage. It's shiny, bouncy and soft to touch.",
  name: "Terry",
  tags: ["Stronger & Longer", "Hair Growth", "Visibly Less Shedding"],
  product: "Nutrafol Women Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women experienced significant hair growth.",
  after: "6",
  action: "Taking",
  pdp: "/nutrafol-core-for-women/",
}

export const aliza = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.ALIZA_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.ALIZA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.ALIZA_AFTER,
  imageDirection: "center",
  quote: null,
  name: "Aliza",
  tags: [
    "Visibly Thicker Hair Volume",
    "Visibly Less Shedding",
    "Stronger & Longer",
  ],
  product: "Nutrafol Women Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women experienced significant hair growth.",
  after: "6",
  action: "Taking",
  pdp: "/nutrafol-core-for-women/",
}

export const dawnte = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.DAWNTE_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.DAWNTE_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.DAWNTE_AFTER,
  imageDirection: "right",
  quote:
    "My results were fast and life changing. I no longer had to be ashamed of my thinning hair because once I started taking it, my hair became thick, strong, and voluminous!",
  name: "Dawnte",
  tags: ["Visibly Fuller", "Visibly Less Shedding", "Stronger Hair Growth"],
  product: "Nutrafol Women Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women experienced significant hair growth.",
  pdp: "/nutrafol-core-for-women/",
  after: "3",
  action: "Taking",
}

export const francine = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.FRANCINE_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.FRANCINE_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.FRANCINE_AFTER,
  imageDirection: "center",
  name: "Francine",
  product: "Nutrafol Women’s Vegan Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women's Vegan experienced significant hair growth.",
  after: "6",
  quote: "",
  action: "Taking",
  tags: ["Increased Scalp Coverage", "Smoother & Softer", "Hair Growth"],
  pdp: "/womens-vegan/",
}

export const cat = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.CAT_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.CAT_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.CAT_AFTER,
  imageDirection: "left",
  name: "Cat",
  product: "Nutrafol Women’s Vegan Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women's Vegan experienced significant hair growth.",
  after: "6",
  quote:
    "My hairline has filled in completely, I barely have any shedding now, and my hair feels healthier, is less brittle and dry, and has more volume.",
  action: "Taking",
  tags: ["Visibly Fuller", "Scalp Coverage", "Less Shedding"],
  pdp: "/womens-vegan/",
}

export const miyoki = {
  icon: "https://images.ctfassets.net/0rbfqd9c4jdo/76GTpssoFSJNdpH8Qn9mfs/f9e10351502ce2c8b39f9d1e5dac50bd/results-miyoki-tn.png?fl=progressive",
  beforeImage:
    "https://images.ctfassets.net/0rbfqd9c4jdo/35o2OfuVEZIwn1ZExdbrCS/5dffaf3645f9cb1ffaaa1290e4833e3c/miyoki_results_before.png?fl=progressive",
  afterImage:
    "https://images.ctfassets.net/0rbfqd9c4jdo/4GKqIatcHDCTdxGBCGVfg8/777edaf1c70153a397091fa27c4045b5/miyoki_results_after.png?fl=progressive",
  imageDirection: "right",
  name: "Miyoki",
  product: "Nutrafol Women’s Vegan Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women's Vegan experienced significant hair growth.",
  pdp: "/womens-vegan/",
  after: "6",
  quote:
    "After taking Nutrafol for 6 months, I have noticed more fullness, length, and even some shine. I have seen improved fullness in my hairline, eyebrows, and eyelashes as well.",
  action: "Taking",
  tags: ["Visibly Fuller", "Less Shedding", "Baby Hairs Growing Out"],
}

export const tanya = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.TANYA_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.TANYA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.TANYA_AFTER,
  imageDirection: "left",
  name: "Tanya",
  product: "Nutrafol Women’s Vegan Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women's Vegan experienced significant hair growth.",
  pdp: "/womens-vegan/",
  after: "3",
  quote:
    "I’ve noticed that when I brush my hair, I don’t shed as much as I used to. I also really feel a difference in the volume of my hair and the thickness. Not only has Nutrafol benefited my hair, it's benefitted my overall wellness, energy, and how I feel on a daily basis.",
  action: "Taking",
  tags: ["Scalp Coverage", "Less Shedding", "Hair Growth"],
}

export const kayla = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.KAYLA_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.KAYLA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.KAYLA_AFTER,
  imageDirection: "center",
  name: "Kayla",
  product: "Nutrafol Women’s Vegan Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women's Vegan experienced significant hair growth.",
  after: "6",
  quote: null,
  action: "Taking",
  tags: ["Visibly Thicker", "Less Shedding", "Hair Growth"],
  pdp: "/womens-vegan/",
}

export const naomi = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.NAOMI_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.NAOMI_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.NAOMI_AFTER,
  imageDirection: "right",
  name: "Naomi",
  product: "Nutrafol Women’s Vegan Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women's Vegan experienced significant hair growth.",
  after: "3",
  quote: null,
  action: "Taking",
  tags: ["Scalp Coverage", "Stronger & Longer", "Less Shedding"],
  pdp: "/womens-vegan/",
}

export const wendy = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.WENDY_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.WENDY_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.WENDY_AFTER,
  imageDirection: "right",
  quote: `The center of my head had very bad thinning. I could only style my hair certain ways. After using Nutrafol my hair is SO much fuller and vibrant. I feel more confident.`,
  name: "Wendy, 55",
  tags: ["Hair Growth", "Thickness", "Less Shedding"],
  product: "Nutrafol Women’s Balance",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women’s Balance experienced significant hair growth.",
  after: "6",
  action: "Taking",
}

export const erica = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.ERICA_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.ERICA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.ERICA_AFTER,
  imageDirection: "right",
  quote: `I noticed my part was separating and thinning all over. I had to comb it over to cover the top. It’s now shiny and full. It looks so great! I am so much happier.`,
  name: "Erica, 50+",
  tags: ["Thickness", "Scalp Coverage", "Shine"],
  product: "Nutrafol Women’s Balance",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women’s Balance experienced significant hair growth.",
  after: "3",
  action: "Taking",
}

export const tamara = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.TAMARA_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.TAMARA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.TAMARA_AFTER,
  imageDirection: "right",
  quote: `My hair was shedding a lot which really affected my confidence. It’s so much more full after taking Nutrafol. I am so happy! All of my edges are filling in.`,
  name: "Tamara, 50",
  tags: ["Hair Growth", "Thickness", "Less Shedding"],
  product: "Nutrafol Women’s Balance",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women’s Balance experienced significant hair growth.",
  after: "6",
  action: "Taking",
}

export const sabina = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.SABINA_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.SABINA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.SABINA_AFTER,
  imageDirection: "right",
  quote: `My part was starting to widen, and my confidence was starting to go down. After taking Nutrafol, my hair looks more full!`,
  name: "Sabina, 52",
  tags: ["Hair Growth", "Thickness", "Growth Rate"],
  product: "Nutrafol Women’s Balance",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women’s Balance experienced significant hair growth.",
  after: "6",
  action: "Taking",
}

export const mitra = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.MITRA_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.MITRA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.MITRA_AFTER,
  imageDirection: "right",
  quote: null,
  name: "Mitra",
  tags: ["Hair Growth", "Thickness", "Less Shedding"],
  product: "Nutrafol Women Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women experienced significant hair growth.",
  after: "6",
  action: "Taking",
}

export const jacqueline = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.JACQUELINE_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.JACQUELINE_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.JACQUELINE_AFTER,
  imageDirection: "center",
  quote:
    "I noticed thinning on the top and sides of my hair, which was starting to become hard to cover up. After taking Nutrafol I noticed I could now wear my hair in more styles.",
  name: "Jacqueline",
  tags: ["Hair Growth", "Thickness", "Less Shedding"],
  product: "Nutrafol Women Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women experienced significant hair growth.",
  after: "6",
  action: "Taking",
}

export const natalia = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.NATALIA_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.NATALIA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.NATALIA_AFTER,
  imageDirection: "center",
  quote:
    "I noticed my hair wasn’t as full as it was in the past. After taking Nutrafol I noticed my hair was more dense, especially around the temple areas and much more shiny!",
  name: "Natalia",
  tags: ["Hair Growth", "Thickness", "Growth Rate"],
  product: "Nutrafol Women Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women experienced significant hair growth.",
  after: "3",
  action: "Taking",
}

export const lera = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.LERA_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.LERA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.LERA_AFTER,
  imageDirection: "center",
  quote:
    "My hair was brittle and thin. Nutrafol gave my hair its life back. It has also made my hair very shiny.",
  name: "Lera",
  tags: ["Scalp Coverage", "Thickness", "Hair Growth"],
  product: "Nutrafol Women Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women experienced significant hair growth.",
  after: "6",
  action: "Taking",
}

export const jessica = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.JESSICA_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.JESSICA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.JESSICA_AFTER,
  imageDirection: "center",
  quote:
    "My hair is definitely shinier, fuller, and looks like it's gotten longer. Same with my nails, my nails have definitely gotten stronger.",
  name: "Jessica",
  tags: ["Baby Hairs Growing Out", "Visibly Longer", "Stronger and Longer"],
  product: "Nutrafol Postpartum Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Postpartum saw significant hair growth.",
  after: "3",
  action: "Taking",
}

export const candace = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.CANDACE_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.CANDACE_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.CANDACE_AFTER,
  imageDirection: "center",
  quote:
    "I have been taking Nutrafol Postpartum for 3 months and I noticed some great changes. My hair has gotten visibly thicker and stronger. It has been a good journey so far.",
  name: "Candace",
  tags: [
    "Visibly Thicker Hair Volume",
    "Visibly Fuller",
    "Visibly Less Shedding",
  ],
  product: "Nutrafol Postpartum Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Postpartum saw significant hair growth.",
  after: "4",
  action: "Taking",
  pdp: "/nutrafol-postpartum-for-women/",
}

export const lilyana = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.LILYANA_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.LILYANA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.LILYANA_AFTER,
  imageDirection: "center",
  quote:
    "I have noticed my hair looks thicker, my curl patterns have come back, my eyebrows look a lot thicker, and my hair length is a lot longer than it was before.",
  name: "Lilyana",
  tags: ["Visibly Less Shedding", "Fuller Hairline", "Baby Hairs Growing Out"],
  product: "Nutrafol Postpartum Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Postpartum saw significant hair growth.",
  pdp: "/nutrafol-postpartum-for-women/",
  after: "6",
  action: "Taking",
}

export const deyanna = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.DEYANNA_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.DEYANNA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.DEYANNA_AFTER,
  imageDirection: "center",
  quote:
    "Experiencing more luscious hair, the fullness, the length, the texture, everything, my natural curls even just flourish on their own. So I am just really thankful for what this product has done for me.",
  name: "De’yanna",
  tags: ["Visibly Less Shedding", "Visibly Fuller", "Stronger and Longer"],
  product: "Nutrafol Postpartum Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Postpartum saw significant hair growth.",
  pdp: "/nutrafol-postpartum-for-women/",
  after: "6",
  action: "Taking",
}

export const neghin = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.NEGHIN_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.NEGHIN_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.NEGHIN_AFTER,
  imageDirection: "center",
  quote:
    "I have been taking Nutrafol Postpartum and I realized that my shedding has significantly decreased and because of that my hairline got fuller and my ends got longer. So that was really exciting.",
  name: "Neghin",
  tags: ["Baby Hairs Growing Out", "Visibly Fuller", "Stronger and Longer"],
  product: "Nutrafol Postpartum Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Postpartum saw significant hair growth.",
  pdp: "/nutrafol-postpartum-for-women/",
  after: "6",
  action: "Taking",
}

export const ensley = {
  icon: IMAGESMAP.RESULTS_WOMEN_NOVA.ENSLEY_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.ENSLEY_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.ENSLEY_AFTER,
  imageDirection: "center",
  quote:
    "Bleaching my hair and adding highlights seriously damaged my hair over the years. I was becoming really insecure about the thinning and noticeable breakage that my hair had. Nutrafol has completely changed my hair.",
  name: "Ensley",
  tags: ["Visibly Fuller", "Visibly Less Shedding", "Stronger and Longer"],
  product: "Nutrafol Women Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women experienced significant hair growth.",
  pdp: "/nutrafol-core-for-women/",
  after: "6",
  action: "Taking",
}

export const erryn = {
  icon: IMAGESMAP.RESULTS_WOMEN.ERRYN_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.ERRYN_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.ERRYN_AFTER,
  imageDirection: "center",
  quote: null,
  name: "Erryn",
  tags: ["Stronger & Longer", "Visibly Fuller", "Baby Hairs Growing Out"],
  product: "Nutrafol Women’s Balance Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women’s Balance experienced significant hair growth.",
  after: "6",
  action: "Taking",
  pdp: "/women-balance/",
}

export const karin = {
  icon: IMAGESMAP.RESULTS_WOMEN.KARIN_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.KARIN_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.KARIN_AFTER,
  imageDirection: "right",
  quote: null,
  name: "Karin",
  tags: [
    "Stronger & Longer",
    "Fuller Scalp Coverage",
    "Baby Hairs Growing Out",
  ],
  product: "Nutrafol Women’s Balance Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women’s Balance experienced significant hair growth.",
  after: "6",
  action: "Taking",
  pdp: "/women-balance/",
}

export const felisha = {
  icon: IMAGESMAP.RESULTS_WOMEN.FELISHA_TN,
  beforeImage: IMAGESMAP.RESULTS_WOMEN_NOVA.FELISHA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_WOMEN_NOVA.FELISHA_AFTER,
  imageDirection: "center",
  name: "Felisha",
  product: "Nutrafol Women’s Vegan Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Women's Vegan experienced significant hair growth.",
  after: "3",
  quote: null,
  action: "Taking",
  tags: ["Hair Growth", "Visibly Thicker", "Stronger & Longer"],
  pdp: "/womens-vegan/",
}

/*
 *  MEN RESULT DATA
 */

export const brian = {
  name: "Brian",
  icon: IMAGESMAP.RESULTS_MEN_NOVA.BRIAN_TN,
  beforeImage: IMAGESMAP.RESULTS_MEN_NOVA.BRIAN_BEFORE,
  afterImage: IMAGESMAP.RESULTS_MEN_NOVA.BRIAN_AFTER,
  imageDirection: "center",
  quote:
    "I’m definitely noticing more hair in the front, where I was thinning, as well as on the top of my head.",
  tags: ["Visibly Fuller", "Scalp Coverage", "Hair Growth"],
  product: "Nutrafol Men Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Men experienced significant hair growth.",
  after: "3",
  action: "Taking",
  pdp: "/men/products/thinning-hair-growth-supplement/",
}

export const jason = {
  name: "Jason",
  icon: IMAGESMAP.RESULTS_MEN.JASON_TN,
  beforeImage: IMAGESMAP.RESULTS_MEN.JASON_BEFORE,
  afterImage: IMAGESMAP.RESULTS_MEN.JASON_AFTER,
  imageDirection: "center",
  quote:
    "Being younger, I wanted to see if there was something out there to help my scalp thinning. My hair has become fuller and thicker because of all of the great ingredients Nutrafol has.",
  tags: ["Visibly Thicker", "Visibly Fuller", "Fast Growing"],
  product: "Nutrafol Men Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Men experienced significant hair growth.",
  pdp: "/men/products/thinning-hair-growth-supplement/",
  after: "3",
  action: "Taking",
}

export const mark = {
  name: "Mark",
  icon: IMAGESMAP.RESULTS_MEN_NOVA.MARK_TN,
  beforeImage: IMAGESMAP.RESULTS_MEN_NOVA.MARK_BEFORE,
  afterImage: IMAGESMAP.RESULTS_MEN_NOVA.MARK_AFTER,
  imageDirection: "center",
  quote: `I was concerned as I was thinning on top. I tried the supplement and saw remarkable improvement. I gained more confidence in myself.`,
  tags: ["Hair Growth", "Stronger Feeling", "Visibly Thicker"],
  product: "Nutrafol Men Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Men experienced significant hair growth.",
  pdp: "/men/products/thinning-hair-growth-supplement/",
  after: "3",
  action: "Taking",
}

export const jose = {
  name: "Jose",
  icon: IMAGESMAP.RESULTS_MEN.JOSE_TN,
  beforeImage: IMAGESMAP.RESULTS_MEN.JOSE_BEFORE,
  afterImage: IMAGESMAP.RESULTS_MEN.JOSE_AFTER,
  imageDirection: "center",
  quote: "My hair is thicker and fuller. I also realized I sleep better.",
  tags: ["Stronger Feeling", "Hair Growth", "Visibly Fuller"],
  product: "Nutrafol Men Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Men experienced significant hair growth.",
  pdp: "/men/products/thinning-hair-growth-supplement/",
  after: "6",
  action: "Taking",
}

export const jon = {
  name: "Jon",
  icon: IMAGESMAP.RESULTS_MEN_NOVA.JON_TN,
  beforeImage: IMAGESMAP.RESULTS_MEN_NOVA.JON_BEFORE,
  afterImage: IMAGESMAP.RESULTS_MEN_NOVA.JON_AFTER,
  imageDirection: "center",
  quote:
    "Being younger, I wanted to see if there was something out there to help my scalp thinning. My hair has become fuller and thicker because of all of the great ingredients Nutrafol has.",
  tags: ["Hair Growth", "Thickness", "Visible Scalp Coverage"],
  product: "Nutrafol Men Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Men experienced significant hair growth.",
  after: "3",
  action: "Taking",
  pdp: "/men/products/thinning-hair-growth-supplement/",
}

export const anuradha = {
  name: "Anuradha",
  icon: IMAGESMAP.RESULTS_MEN_NOVA.ANURADHA_TN,
  beforeImage: IMAGESMAP.RESULTS_MEN_NOVA.ANURADHA_BEFORE,
  afterImage: IMAGESMAP.RESULTS_MEN_NOVA.ANURADHA_AFTER,
  imageDirection: "center",
  quote:
    "My hair was starting to shed and that was affecting my confidence. I’m happy I found something that helps me keep my hair looking thicker and fuller.",
  tags: ["Visibly Fuller", "Visibly Thicker", "Visibly Less Shedding"],
  product: "Nutrafol Men Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Men experienced significant hair growth.",
  after: "3",
  action: "Taking",
  pdp: "/men/products/thinning-hair-growth-supplement/",
}

export const jim = {
  name: "Jim",
  icon: IMAGESMAP.RESULTS_MEN_NOVA.JIM_TN,
  beforeImage: IMAGESMAP.RESULTS_MEN_NOVA.JIM_BEFORE,
  afterImage: IMAGESMAP.RESULTS_MEN_NOVA.JIM_AFTER,
  imageDirection: "center",
  quote:
    "I have been taking Nutrafol Men for 3 months now. My son told me that the back of my hair looks fuller. He took a picture and I compared it and it was awesome.",
  tags: ["Scalp Coverage", "Fast Growing", "Visibly Fuller"],
  product: "Nutrafol Men Hair Growth Nutraceutical",
  slideDisclaimer:
    "In a 6-month clinical study, participants taking Nutrafol Men experienced significant hair growth.",
  after: "4",
  action: "Taking",
  pdp: "/men/products/thinning-hair-growth-supplement/",
}
